// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f9dcf193","239":"10d83d3e","455":"71128df9"}[chunkId] + ".chunk.js";
};